import { Flex, Skeleton } from 'antd';

const EmpCardSkeleton = () => {
  return (
    <div className="p-6 bg-theme-slate-800 h-full border border-theme-slate-700 rounded-xl space-y-5">
      <Flex justify="space-between" align="center">
        <Skeleton.Avatar active size={70} shape="circle" />
        <Skeleton.Button active size="small" />
      </Flex>
      <div className="space-y-4">
        <Flex align="center" gap={8}>
          <Skeleton.Input active />
          <Skeleton.Button active />
        </Flex>
        <Flex align="center" gap={8}>
          <Skeleton.Input active />
          <Skeleton.Input active />
        </Flex>
        <Flex align="center" gap={8}>
          <Skeleton.Input active />
          <Skeleton.Input active />
        </Flex>
      </div>
    </div>
  );
};

export default EmpCardSkeleton;
